export const English: string = 'EN';
export const Spanish: string = 'SP';
export const French: string = 'FR';
export const German: string = 'GE';
export const HMong: string = 'HM';
export const Chinese: string = 'CH';


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/languages.ts